<template>
<div class="page_map index pageSearch page_item bg">
    <div class="index_top">
        <div class="page-search">
            <van-row type="flex" justify="space-start">
                <van-col :span="1"></van-col>
                <van-col :span="20">
                    <van-cell-group class="search_field">
                        <van-field v-model="search_value" :placeholder="placeholder">
                            <van-icon slot="right-icon" :name="righticon" @click="search" />
                        </van-field>
                        <!-- 可优化关联手机键盘搜索按钮 还需再完善 -->
                        <!-- <van-field v-model="search_value" :placeholder="placeholder" type="search" @keyup.13="show" @blur="search" ref="input1">
                            <van-icon slot="right-icon" :name="righticon" />
                        </van-field> -->
                    </van-cell-group>
                </van-col>
                <van-col :span="3" class="search_ac" @click="cancel">取消</van-col>
            </van-row>
        </div>
    </div>
    <!-- 分类 -->
    <div class="page">
        <van-tabs v-model="active" swipe-threshold="6" @change="changeTab">
            <van-tab title="商品" :name="5" v-if="!is_map"></van-tab>
            <van-tab title="匠人" :name="6" v-if="!is_map"></van-tab>
            <van-tab title="约·看" :name="7" v-if="!is_map"></van-tab>
            <van-tab title="非遗" :name="0" v-if="is_map"></van-tab>
            <van-tab title="乡村振兴" :name="1" v-if="is_map"></van-tab>
            <van-tab title="红馆" :name="2" v-if="is_map"></van-tab>
            <van-tab title="景区" :name="3" v-if="is_map"></van-tab>
            <van-tab title="农特产品" :name="4" v-if="is_map"></van-tab>
        </van-tabs>
    </div>
    <!-- 地图的搜索历史 -->
    <div class="search_fenlei" v-if="is_map && mapSearchRecord.length!=0">
        <div class="search_title">历史记录</div>
        <ul class="search_list clearfix">
            <li :class="item.status ? 'search_item f-l slh_s active' : 'search_item f-l slh_s'" v-for="(item,index) in mapSearchRecord" :key="index" @click="searchRecordFun(item)">{{item.name}}</li>
        </ul>
    </div>
    <!-- 商品 匠人 约看的搜索历史 -->
    <div class="search_fenlei" v-if="!is_map && searchRecord.length!=0">
        <div class="search_title">历史记录</div>
        <ul class="search_list clearfix">
            <li :class="item.status ? 'search_item f-l slh_s active' : 'search_item f-l slh_s'" v-for="(item,index) in searchRecord" :key="index" @click="searchRecordFun(item)">{{item.name}}</li>
        </ul>
    </div>
    <!-- 渲染列表 地图数据-->
    <van-list v-model="loading" :finished="finished" :finished-text="finishedText" @load="getMapData" v-if="is_map">
        <div class="content" v-if="is_map">
            <ul class="list">
                <li class="item clearfix" v-for="item in dataList">
                    <div class="thumb f-l" @click="goItemInfo(item.id)" v-if="item.item">
						<van-image fit="cover" :show-loading="false" :src="item.item.thumb ? imageUrl+item.item.thumb : item.item_first_tu ? imageUrl+item.item_first_tu : $publicData.intangibleDefault" :error-icon="$publicData.intangibleDefault" />
                        <!-- <img :src="item.item.thumb ? item.item.thumb : $publicData.intangibleDefault" alt style="height:100%" /> -->
                    </div>
                    <div class="info f-l">
                        <div class="title clearfix" @click="goItemInfo(item.id)">
                            <span class="tag" v-if="item.item.level">{{item.item.level.title}}</span>
                            <span class="txt">{{item.title}}</span>
                        </div>
                        <div class="juli clearfix" @click="goItemInfo(item.id)">
                            <span class="f-l tag" v-if="item.item.cate">{{item.item.cate.name}}</span>
                            <span class="f-r num" v-if="item.distance>0">距离约 {{(item.distance/1000).toFixed(2)}}千米</span>
                        </div>
                        <div class="adress clearfix" @click="goItemInfo(item.id)">
                            <span class="f-l">地址：</span>
                            <div class="f-l detail">
                                <span v-if="item.item.area1">{{item.item.area1.areaname}}</span>
                                <span v-if="item.item.area2">{{'>'+item.item.area2.areaname+'>'}}</span>
                                <span v-if="item.item.area3">{{item.item.area3.areaname}}</span>
                            </div>
                        </div>
                        <div class="bottom clearfix">
                            <div class="action f-l" @click="goShop(item.tradesman_id)">店铺</div>
                            <div class="action f-l" @click="goSomeWhere(item.lng,item.lat,item.title)">去这里</div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </van-list>
    <!-- 渲染 商品数据 -->
    <van-list v-model="loading_goods" :finished="finished_goods" :finished-text="finishedText" @load="getGoodsData" v-if="!is_map && active==5">
        <div class="datalist page_goods" v-if="!is_map && active==5">
            <ul class="list">
                <li class="item" v-for="goods in goodsList" :key="goods.id" @click="goShopDetail(goods)">
                    <div :class="goods.is_blockchain ? 'thumb blockchain' : 'thumb'">
                        <!-- <img :src="goods.good_thumb ? goods.good_thumb : $publicData.intangibleDefault" alt="" /> -->
                        <van-image class="vanImage" fit="contain" :show-error="false" :show-loading="false" :src="goods.good_thumb ? imageUrl+goods.good_thumb : $publicData.intangibleDefault" />
                    </div>
                    <div class="item_xinxi">
                        <div class="title_wrap single">
                            <div class="title_tag">
                                <span class="icon_self" v-if="goods.is_self">自营</span>
                                <span class="icon_new" v-if="goods.is_new">最新</span>
                            </div>
                            <span v-if="goods.is_self && goods.is_new" class="title title1 slh_s"> {{ goods.good_title }}</span>
                            <span v-else-if="goods.is_self || goods.is_new" class="title title2 slh_s"> {{ goods.good_title }}</span>
                            <span v-else class="title title3 slh_s"> {{ goods.good_title }}</span>
                        </div>
                        <div class="info clearfix">
                            <div class="shop_name f-l slh_s">{{ goods.tradesman_name?goods.tradesman_name :'' }}</div>
                            <div class="source f-r">{{ goods.place }}</div>
                        </div>
                        <div class="info">
                            <span class="f-l price">¥{{ goods.good_price }}</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </van-list>
    <!-- 渲染 匠人数据 -->
    <div class="page_iteminfo" v-if="!is_map && active==6">
        <van-list v-model="loading_tradesman" :finished="finished_tradesman" :finished-text="finishedText" @load="getTradesmanData">
            <div class="jiangren">
                <div class="con" v-for="tradesman in tradesmanList">
                    <div class="con_info clearfix" @click="goTradesmanDetail(tradesman)">
                        <div class="thumb f-l">
                            <img :src="tradesman.thumb ? ($publicData.withHttpStart(tradesman.thumb) ? tradesman.thumb : imageUrl+tradesman.thumb ) : $publicData.defaultTouxiang" alt="" class="">
                        </div>
                        <div class="f-l con_info_r">
                            <div class="name slh_s">{{ tradesman.nickname }}</div>
                            <div class="tag slh_s" v-if="tradesman.data.auth_company">{{ (tradesman.data.auth_company).length>5 ? (tradesman.data.auth_company).slice(0,5)+'...' : tradesman.data.auth_company }}</div>
                        </div>
                    </div>
                    <div :class="tradesman.is_attention==1 ? 'guanzhu': 'guanzhu guanzhu_no'" @click="attentionTadesmanFun(tradesman)">{{ tradesman.is_attention==1?'已关注':'关注' }}</div>
                </div>
            </div>
        </van-list>
    </div>
    <!-- 渲染 约看数据 -->
    <div class="page_yuekan page" v-if="!is_map && active==7">
        <van-list v-model="loading_yuekan" :finished="finished_yuekan" :finished-text="finishedText" @load="getYuekanData">
            <div class="product">
                <div class="pro_item clearfix" v-for="item in yuekanList" :key="item.id" @click="goYuekanDetail(item.id)">
                    <div class="pro_item_l f-l">
                        <img :src="imageUrl+item.thumb" alt="" class="tu">
                    </div>
                    <div class="pro_item_r f-l">
                        <div class="pro_item_r_t clearfix">
                            <div class="title f-l slh">{{item.title}}</div>
                            <div class="price f-r"><span class="tag_cash">¥</span>{{item.price}}</div>
                        </div>
                        <div class="pro_item_r_b">
                            <div class="info clearfix">
                                <div class="info_l f-l">位置：</div>
                                <div class="info_r f-l slh_s">
                                    <span v-if="item.provice">{{item.provice.areaname}}</span>
                                    <span v-if="item.city">{{ '>' + item.city.areaname}}</span>
                                    <span v-if="item.area">{{'>' + item.area.areaname}}</span>
                                </div>
                            </div>
                            <div class="info clearfix">
                                <div class="info_l f-l">类型：</div>
                                <div class="info_r f-l slh_s">{{item.type.title}}</div>
                            </div>
                            <div class="info clearfix">
                                <div class="info_l f-l">简介：</div>
                                <div class="info_r slh f-l">{{item.describe}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;
export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            routeName: this.$route.query.routeName,
            active: parseInt(this.$route.query.type_id),
            placeholder: '请输入',
            search_value: '',
            righticon: process.env.BASE_URL + '/statics/images/search_ico.png',
            pages: {
                page: 1,
                size: 10
            },
            loading: false,
            finished: false,
            dataList: [],
            lng: localStorage.getItem('lng') ? localStorage.getItem('lng') : localStorage.getItem('lngDefault'),
            lat: localStorage.getItem('lat') ? localStorage.getItem('lat') : localStorage.getItem('latDefault'),
            is_map: null, // 判断是否 从地图相关页面进来
            // is_shop: null, // 判断是否 从b2c相关页面进来
            loading_goods: false, // 商品
            finished_goods: false, // 商品
            goodsList: [], // 商品数据
            loading_tradesman: false, // 匠人
            finished_tradesman: false, // 匠人
            tradesmanList: [], // 匠人
            finishedText: '', // 加载完成后的提示文案，默认是空，当加载完成时为'没有更多了'
            // unload: false, // 控制请求不同接口时，list组件 load方法自动加载
            mapSearchRecord: [], // 地图搜索历史
            searchRecord: [], // 商品 匠人 约看搜索历史
            yuekanList: [], // 约看数据
            loading_yuekan: false, // 约看
            finished_yuekan: false, // 约看
            hasItem: false, // 用于判断搜索记录是否有重复的名字
			token: ''
        }
    },
    created() {
        console.log(this.$route.query)
        // 根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '搜索'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token

                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
        }
        var params2 = {
                'data': {
                }
            }
            console.log(111111111,params2)
            this.$bridge.callhandler('sdjy://public/getLocationInfo', params2, (data) => {
                console.log(111111111)
                console.log(data)
                if (data.code == 200) {
                    this.lat = data.result.latitude
                    this.lng = data.result.longitude
                } else {
                    this.lat = null
                    this.lng = null
                }
            })
        // 判断是否 从地图相关页面进来
        if (this.routeName.match(/map/)) {
            this.is_map = true
            this.mapSearchRecord = JSON.parse(localStorage.getItem('mapSearchRecord')) ? JSON.parse(localStorage.getItem('mapSearchRecord')) : []
            console.log('this.mapSearchRecord', this.mapSearchRecord)
        } else {
            this.searchRecord = JSON.parse(localStorage.getItem('searchRecord')) ? JSON.parse(localStorage.getItem('searchRecord')) : []
		}
	},
    methods: {
        // 获取地图数据
        getMapData() {
            // 不是地图
            if (!this.is_map) {
                this.finished = true
                return
            }
            if (!this.search_value) {
                this.finished = true
                return
            }
            console.log('加载地图数据')
            var params = {
                token: this.token,
                lng: this.lng,
                lat: this.lat,
                key: this.search_value,
                page: this.pages.page,
                size: this.pages.size
            }
            if (this.is_map) {
                var arr = []
                arr.push(this.active)
                params.type_id = arr
            }
            this.$api.map.searchItem(params).then(res => {
                console.log('res')
                if (res.code == 200) {
                    console.log('res')
                    console.log(res)
                    var list = res.result
                    for (var i in list) {
						// 无缩略图,取内容的第一张图片
						var content = list[i].item.content
						list[i].item_first_tu = this.imgUrlFun(content)
                        this.dataList.push(list[i])
                    }
                    if (list.length < this.pages.size || list.length == 0) {
                        // 数据加载完
                        this.finished = true
                        this.finishedText = '没有更多了'
                        // return
                    }
                } else {
                    // 接口出错
                    this.finished = true
                    // return
                }
                // 分页加载
                this.pages.page++
                this.loading = false
            })
        },
        // 搜索
        search() {
            if (!this.search_value) {
                return
            }
            console.log('search')
            // this.unload = false
            this.pages.page = 1
            if (this.is_map) {
                this.dataList = []
                this.getMapData()
            }
            if (this.active == 5) {
                this.goodsList = []
                this.getGoodsData()
            }
            if (this.active == 6) {
                this.tradesmanList = []
                this.getTradesmanData()
            }
            if (this.active == 7) {
                this.yuekanList = []
                this.getYuekanData()
            }
            // 地图搜索记录
            if (this.is_map) {
                console.log('this.mapSearchRecord', this.mapSearchRecord)
                for (var i in this.mapSearchRecord) {
                    this.mapSearchRecord[i].status = 0
                    if (this.mapSearchRecord[i].name == this.search_value) {
                        this.hasItem = true
                        return
                    }
                }
                if (!this.hasItem) {
                    this.mapSearchRecord.unshift({
                        name: this.search_value,
                        status: 0
                    })
                }
                if (this.mapSearchRecord.length > 5) {
                    this.mapSearchRecord.pop()
                }
                localStorage.setItem('mapSearchRecord', JSON.stringify(this.mapSearchRecord));
            }
            // 商品匠人约看搜索记录
            if (!this.is_map) {
                for (var j in this.searchRecord) {
                    this.searchRecord[j].status = 0
                    if (this.searchRecord[j].name == this.search_value) {
                        this.hasItem = true
                        return
                    }
                }
                if (!this.hasItem) {
                    this.searchRecord.unshift({
                        name: this.search_value,
                        status: 0
                    })
                }
                console.log('this.searchRecord', this.searchRecord)

                if (this.searchRecord.length > 5) {
                    this.searchRecord.pop()
                }
                localStorage.setItem('searchRecord', JSON.stringify(this.searchRecord));
            }
            // 
        },
        // 查询 搜索记录
        searchRecordFun(item) {
            console.log('searchRecordFun')
            // item 是搜索记录
            this.search_value = item.name
            this.pages.page = 1
            if (this.is_map) {
                this.dataList = []
                for (var i in this.mapSearchRecord) {
                    if (this.mapSearchRecord[i].name == item.name) {
                        item.status = 1
                    } else {
                        this.mapSearchRecord[i].status = 0
                    }
                }
                this.getMapData()
            }
            if (!this.is_map) {
                for (var j in this.searchRecord) {
                    if (this.searchRecord[j].name == item.name) {
                        item.status = 1
                    } else {
                        this.searchRecord[j].status = 0
                    }
                }
                // 商品
                if (this.active == 5) {
                    this.goodsList = []
                    this.getGoodsData()
                }
                // 匠人
                if (this.active == 6) {
                    this.tradesmanList = []
                    this.getTradesmanData()
                }
                // 约看
                if (this.active == 7) {
                    this.yuekanList = []
                    this.getYuekanData()
                }
            }
        },
        // 取消
        cancel() {
            this.search_value = ''
        },
        // 切换tab
        changeTab() {
            console.log('changeTab')
            this.pages.page = 1
            this.finishedText = ''
            console.log('切换')
            if (this.is_map) {
                this.dataList = []
                this.getMapData()
            }
            if (this.active == 5) {
                this.goodsList = []
                if (this.loading_goods) {
                    return;
                }
                this.loading_goods = true;
                this.finished_goods = false;
                this.getGoodsData()
            }
            if (this.active == 6) {
                this.tradesmanList = [];
                if (this.loading_tradesman) {
                    return;
                }
                this.loading_tradesman = true;
                this.finished_tradesman = false;
                this.getTradesmanData()
            }
            if (this.active == 7) {
                this.yuekanList = []
                if (this.loading_yuekan) {
                    return;
                }
                this.loading_yuekan = true;
                this.finished_yuekan = false;
                this.getYuekanData()
            }
            console.log('this.acitve', this.active)
        },
        // 项目详情
        goItemInfo(id) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + '/item/detail?id=' + id
                    }
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    data => {}
                );
            } else {
                this.$router.push({
                    path: "/item/detail",
                    query: {
                        id: id
                    }
                });
            }
        },
        // 去这里
        goSomeWhere(lng, lat, name) {
            console.log('window')
            console.log(window)
            window.location.href = '//uri.amap.com/marker?position=' + lng + ',' + lat + '&name=' + name
        },
        // 去店铺
        goShop(id) {
            this.$router.push({
                path: '/art/detail',
                query: {
                    tradesmanId: id
                }
            })
        },
        // 获取商品数据
        getGoodsData() {
            // if(this.unload){
            // 	this.finished_goods = true
            //     return
            // }
            if (this.active != 5) {
                this.loading_goods = false
                this.finished_goods = true
                return
            }
            if (!this.search_value) {
                this.loading_goods = false
                this.finished_goods = true
                return
            }
            console.log('加载商品')
            var params = {
                token: this.token,
                keyword: this.search_value,
                page: this.pages.page,
				size: this.pages.size,
				
			};
			// 如果从区块链商城过来的
			if(this.routeName == 'chain-index'){
				params.is_blockchain = 1  // 1是 0否 空全部
			}

            this.$api.shop.goodsList(params).then((res) => {
                if (res.code == 200) {
                    var list = res.result.list
                    for (var i in list) {
                        this.goodsList.push(list[i])
                    }
                    if (list.length < this.pages.size || list.length == 0) {
                        // 数据加载完
                        this.finished_goods = true
                        this.finishedText = '没有更多了'
                        // return
                    }
                } else {
                    this.finished_goods = true
                    // return
                }
                this.pages.page++
                this.loading_goods = false
            });
        },
        // 商品详情
        goShopDetail(goods) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var p = "?goodsId=" + goods.good_id;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + "/shop/detail" + p
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://public/openNewWebView",
                    params,
                    (data) => {}
                );
            } else {
                this.$router.push({
                    path: "/shop/detail",
                    query: {
                        goodsId: goods.good_id,
                    },
                });
            }
        },
        // 匠人数据
        getTradesmanData() {
            // if(this.unload){
            // 	this.finished_tradesman = true
            //     return
            // }
            console.log('加载匠人', this.loading_tradesman)

            if (this.active != 6) {
                this.loading_tradesman = false;
                this.finished_tradesman = true
                return
            }
            if (!this.search_value) {
                this.loading_tradesman = false;
                this.finished_tradesman = true
                return
            }
            var params = {
                token: this.token,
                keyword: this.search_value,
                page: this.pages.page,
                size: this.pages.size
            }
            this.$api.tradesman.list(params).then(res => {
                if (res.code == 200) {
                    var list = res.result.list;
                    for (var i in list) {
                        this.tradesmanList.push(list[i])
                    }
                    if (list.length < this.pages.size || list.length == 0) {
                        // 数据加载完
                        this.finished_tradesman = true
                        this.finishedText = '没有更多了'
                        // return
                    }
                } else {
                    this.finished_tradesman = true
                    // return
                }
                this.pages.page++
                this.loading_tradesman = false
            })
        },
        // 匠人详情
        goTradesmanDetail(tradesman) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/detail?tradesmanId=' + tradesman.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/detail',
                    query: {
                        tradesmanId: tradesman.id
                    }
                })
            }
		},
		// 关注 区分app H5
		attentionTadesmanFun(tradesman){
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					data: {},
				};
				this.$bridge.callhandler(
					"sdjy://member/memberInfo",
					memberParams,
					(data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							this.attentionTadesman(tradesman)
						}
					}
				);
			} else {
				// console.log('对App和H5做判断')
				this.attentionTadesman(tradesman)
			}
		},
        // 关注
        attentionTadesman(tradesman) {
            if (tradesman.is_attention == 1) {
                return;
            }
            var params = {
                token: this.token,
                tradesman_id: tradesman.id,
                type: 1
            }
            console.log(params)
            this.$api.tradesman.attention(params).then(res => {
                if (res.code == 200) {
                    this.$toast('关注成功')
                    this.pages.page = 1
                    this.active = 6
                    this.tradesmanList = []
                    this.getTradesmanData()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 约看数据
        getYuekanData() {
            if (this.active != 7) {
                this.loading_yuekan = false
                this.finished_yuekan = true
                return
            }
            if (!this.search_value) {
                this.loading_yuekan = false
                this.finished_yuekan = true
                return
            }
            var params = {
                token: this.token,
                keyword: this.search_value,
                page: this.pages.page,
                size: this.pages.size
            }
            this.$api.live.index(params).then(res => {
                if (res.code == 200) {
                    var list = res.result.list;
                    for (var i in list) {
                        this.yuekanList.push(list[i])
                    }
                    if (list.length < this.pages.size || list.length == 0) {
                        // 数据加载完
                        this.finished_yuekan = true
                        this.finishedText = '没有更多了'
                        // return
                    }
                } else {
                    this.finished_yuekan = true
                    // return
                }
                this.pages.page++
                this.loading_yuekan = false
            })
        },
        // 约看详情
        goYuekanDetail(id) {
            this.$router.push({
                path: '/yuekan/detail',
                query: {
                    id: id
                }
            })
        },
        // 关联上键盘搜索，还需要测试ios
        show() {
            this.$refs.input1.blur();
		},
		// js富文本取第一张图片
        imgUrlFun: function(str) {
            var data = "";
            str.replace(/\<img [^>]*src=['"]([^'"]+)[^>]*\>/, function(
                match,
                capture
            ) {
				// console.log('match',match) // 匹配到的字符串
				// console.log('captrue',capture) // 匹配到的子串
                data = capture;
            });
            return data;
        }
    },
}
</script>

<style scoped>
/deep/.van-row--justify-space-between {
    justify-content: flex-start;
}

/deep/.van-tabs__nav {
    display: block;
    white-space: nowrap;
    padding-left: .57rem;
}

/deep/.page .van-tab {
    display: inline-block;
    margin-right: .53rem;
    color: rgba(51, 51, 51, 1);
}

/deep/input::placeholder {
    color: #fff !important;
}
/deep/.page_iteminfo .jiangren .con{
	padding-left: 0;
}
</style>
